/** @jsxImportSource theme-ui */
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'

import { getLayouts } from '../../utils/api'
import { Container } from '../../components/PageLayout/Container'
import { LayoutsListCard } from './LayoutsListCard'
import { Breadcrumbs } from '../../components/PageLayout/Breadcrumbs'

export function LayoutsList() {
  const { isLoading, isError, data, error } = useQuery('layouts', getLayouts)

  return (
    <Container>
      <Breadcrumbs />
      <ul
        sx={{
          display: 'grid',
          gap: '20px',
          gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr 1fr'],
        }}
        data-cy="layout-list"
      >
        {isLoading && <h1>Loading...</h1>}
        {isError && <h1>{error.message}</h1>}
        {data?.data &&
          data.data.map((layout, i) => (
            <li sx={{ display: 'block' }} key={i}>
              <Link
                to={`layout/${layout.id}`}
                sx={{ color: 'white', textDecoration: 'none', fontSize: '20px' }}
              >
                <LayoutsListCard layout={layout} />
              </Link>
            </li>
          ))}
      </ul>
    </Container>
  )
}
